<template>
    <div class="yt-modal-component">
        <button v-if="isButton === true" class="btn btn-primary" @click="openModal()">
            <slot />
        </button>
        <div @click="openModal()" v-else>
            <slot />
        </div>

        <modal :name="modalName" ref="modalComponent" transition="pop-out" :width="width" height="auto" :scrollable="true" :adaptive="true" :reset="true">
            <div class="p-2">
                <div class="card">
                    <h5 class="card-header">
                        {{ component.modalTitle }}
                        <button type="button" class="close" @click="hideModal()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </h5>
                    <div class="card-body">
                        <component :is="component.component" v-bind="component.componentProps" />
                    </div>
                </div>
            </div>
        </modal>
    </div>
    
</template>

<script>
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component()
export default class ModalComponent extends Vue {
    @Prop({
        type: [String, Number],
        default: ''
    })
    id

    @Prop({
        type: Boolean,
        default: true
    })
    isButton

    @Prop({
        type: [String, Number],
        default: 600
    })
    width

    @Prop({
        type: Object,
        required: true,
        default: () => {
            return {
                width: 656,
                modalTitle: null,
                component: null,
                componentProps: {}
            }
        }
    })
    component

    created () {
        this.modalName = `modal-component-${this.id}`
    }

    openModal () {
        // this.$modal.show(this.modalName)
        this.$refs.modalComponent.toggle(true)
    }

    hideModal () {
        // this.$modal.hide(this.modalName)
        this.$refs.modalComponent.toggle(false)
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/ModalComponent.vue